import React, { useState } from 'react'
import { DataGrid, GridColDef } from '@mui/x-data-grid'
import { useSelector } from 'react-redux'
import { State } from '../types/state'
import { Button, Fab } from '@mui/material'
import AddIcon from '@mui/icons-material/Add'
import EditIcon from '@mui/icons-material/Edit'
import DeleteIcon from '@mui/icons-material/Delete'
import NewOrEditUserDialog from './NewOrEditUserDialog'
import DeleteUserDialog from './DeleteUserDialog'
import { useIsLargeView, useIsMobileView } from '../hooks/useIsMobileView'
import { useRequests } from '../requests/useRequests'
import { Role } from '../types/user'

const Users = (): JSX.Element => {
  const requestMaker = useRequests()

  const { users } = useSelector((state: State) => state.user)
  const [selectedRowIds, setSelectedRowIds] = useState<number[]>([])
  const [selectedRowIdsToDelete, setSelectedRowIdsToDelete] = useState<
    number[]
  >([])
  const [user, setUser] = useState<any | null>(null)
  const [isNewOrEditUserDialogOpen, setIsNewOrEditUserDialogOpen] =
    useState(false)
  const [isDeleteUserDialogOpen, setIsDeleteUserDialogOpen] = useState(false)
  const isMobileView = useIsMobileView()
  const isLargeView = useIsLargeView()

  const OptionsButton: React.FC<{ id: number }> = ({ id }) => {
    return (
      <div>
        <Fab
          size='small'
          onClick={() => {
            setUser(users.find(u => u.id === id) as any)
            setIsNewOrEditUserDialogOpen(true)
          }}
          color='warning'
          aria-label='edit'
          style={{ transform: 'scale(0.8)' }}
        >
          <EditIcon />
        </Fab>
        <Fab
          size='small'
          onClick={() => {
            setSelectedRowIdsToDelete([id])
            setIsDeleteUserDialogOpen(true)
          }}
          color='error'
          aria-label='delete'
          style={{ transform: 'scale(0.8)' }}
        >
          <DeleteIcon />
        </Fab>
      </div>
    )
  }

  const columns: GridColDef[] = [
    { field: 'username', headerName: 'Username', width: 120 },
    { field: 'firstName', headerName: 'First name', width: 120 },
    { field: 'lastName', headerName: 'Last name', width: 120 },
    { field: 'email', headerName: 'Email', width: 200 },
    { field: 'role', headerName: 'Role', width: 130 },
    {
      field: 'options',
      headerName: '',
      width: 100,
      renderCell: params => <OptionsButton id={params.row.id} />
    }
  ]

  const onStudentInput = (e: any) => {
    const file = e.target.files[0]

    if (file) {
      const reader = new FileReader()

      reader.onload = async (event: any) => {
        const fileContent = event.target.result

        const lines = fileContent.split('\n')
        lines.shift()

        for (const line of lines) {
          const [username, firstName, lastName, email] = line.trim().split(',')

          const newUser = {
            username,
            email,
            firstName,
            lastName,
            role: Role.STUDENT,
            password: `password${username}`
          }

          console.log({ newUser })

          await requestMaker.createUser(newUser)
          await new Promise(resolve => setTimeout(resolve, 1000))
        }
      }

      reader.readAsText(file)
    }
  }

  const onParentInput = (e: any) => {
    const file = e.target.files[0]

    if (file) {
      const reader = new FileReader()

      reader.onload = async (event: any) => {
        const fileContent = event.target.result

        const lines = fileContent.split('\n')
        lines.shift()

        for (const line of lines) {
          const [username, firstName, lastName, email] = line.trim().split(',')

          const newUser = {
            username,
            email,
            firstName,
            lastName,
            role: Role.PARENT,
            password: `password${username}`
          }

          console.log({ newUser })

          await requestMaker.createUser(newUser)
          await new Promise(resolve => setTimeout(resolve, 1000))
        }
      }

      reader.readAsText(file)
    }
  }

  return (
    <div
      style={{
        height: isMobileView ? '75vh' : '60vh',
        width: isMobileView ? '80vw' : isLargeView ? '50vw' : '70vw',
        margin: 'auto',
        marginBottom: '5vw'
      }}
    >
      <Fab
        size='small'
        color='primary'
        aria-label='add'
        onClick={() => {
          setUser(null)
          setIsNewOrEditUserDialogOpen(true)
        }}
        style={{ margin: '1vw' }}
      >
        <AddIcon />
      </Fab>
      <Fab
        size='small'
        onClick={() => {
          setSelectedRowIdsToDelete(selectedRowIds)
          setIsDeleteUserDialogOpen(true)
        }}
        color='error'
        aria-label='delete'
        disabled={selectedRowIds.length === 0}
      >
        <DeleteIcon />
      </Fab>
      {/* <Button onClick={importUsers} type='submit' variant='contained'>
        Import users
      </Button> */}
      <input
        type='file'
        style={{ margin: '5px' }}
        onChange={e => onStudentInput(e)}
      />
      <input
        type='file'
        style={{ margin: '5px' }}
        onChange={e => onParentInput(e)}
      />
      <DataGrid
        disableRowSelectionOnClick
        rows={users}
        columns={columns}
        checkboxSelection
        onRowSelectionModelChange={newSelection => {
          setSelectedRowIds(newSelection as number[])
        }}
      />
      {isNewOrEditUserDialogOpen && (
        <NewOrEditUserDialog
          handleClose={() => setIsNewOrEditUserDialogOpen(false)}
          user={user}
        />
      )}
      {isDeleteUserDialogOpen && (
        <DeleteUserDialog
          handleClose={() => setIsDeleteUserDialogOpen(false)}
          ids={selectedRowIdsToDelete}
        />
      )}
    </div>
  )
}

export default Users
